module.exports = __webpack_public_path__ + "img/w.5cce5ef1.png";